import HeygenVideoView from "@features/tools/view/heygen-video-view";

const HeygenVideoGenerator = () => {
  return <HeygenVideoView />;
};

export default HeygenVideoGenerator;
